const copies = {
  doubts: '¿Tienes dudas?',
  contactUs: 'Escríbenos por',
  wp: 'WhatsApp'
}

export default copies
